import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePassword() {
  const { user, refreshUser, logout } = useAuth();
  const navigate = useNavigate();
  const [cur, setCur] = useState("");
  const [np1, setNp1] = useState("");
  const [np2, setNp2] = useState("");
  const [busy, setBusy] = useState(false);

  if (!user) return <Navigate to="/admin/login" replace/>;

  const handle = async (e) => {
    e.preventDefault();
    if (np1 !== np2) return toast.error("Passwords do not match");
    if (np1.length < 8) return toast.error("New password must be at least 8 characters");
    setBusy(true);
    try {
      await api.post("/admin/auth/change-password", { current_password: cur, new_password: np1 });
      toast.success("Password changed. Please sign in again.");
      await logout();
      navigate("/admin/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-6">
      <form onSubmit={handle} className="w-full max-w-md border border-zinc-200 bg-white rounded-lg p-10" data-testid="change-password-form">
        <p className="tech-label">First login</p>
        <h1 className="mt-2 font-display text-3xl font-black tracking-tighter">Change your password</h1>
        <p className="text-sm text-zinc-500 mt-2">For security you must set a new password before accessing the dashboard.</p>
        <div className="mt-8 space-y-4">
          <div>
            <Label className="tech-label">Current Password</Label>
            <Input value={cur} onChange={(e) => setCur(e.target.value)} type="password" required className="h-12 bg-zinc-50 mt-2" data-testid="cp-current"/>
          </div>
          <div>
            <Label className="tech-label">New Password (min 8)</Label>
            <Input value={np1} onChange={(e) => setNp1(e.target.value)} type="password" required minLength={8} className="h-12 bg-zinc-50 mt-2" data-testid="cp-new"/>
          </div>
          <div>
            <Label className="tech-label">Confirm New Password</Label>
            <Input value={np2} onChange={(e) => setNp2(e.target.value)} type="password" required minLength={8} className="h-12 bg-zinc-50 mt-2" data-testid="cp-confirm"/>
          </div>
          <Button type="submit" disabled={busy} className="w-full h-12 bg-zinc-900 text-white" data-testid="cp-submit">{busy ? "Updating…" : "Update Password"}</Button>
        </div>
      </form>
    </div>
  );
}
